export default __webpack_public_path__ + "static/media/aleksandra_dagunts.2867786a.png";